package com.anjuros.website.templates.template5.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template5.components.Template5SectionTitle
import com.anjuros.website.templates.template5.modules.Template5HeaderItem
import com.anjuros.website.templates.template5.modules.Template5Review
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.modules.getColorOpacity
import com.anjuros.website.templates.template5.modules.getColorOpacity2
import com.anjuros.website.templates.template5.styles.Template5ReviewPaddingStyle
import com.anjuros.website.templates.template5.styles.Template5ReviewSizeStyle
import com.anjuros.website.templates.template5.util.ResKey
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template5ReviewSection() {

    val clickedIndex = remember { mutableStateOf(0) }

    val currentReview = Template5Review.entries[clickedIndex.value]
    Column(
        modifier = Modifier
            .id(Template5HeaderItem.REVIEWS.id)
            .fillMaxWidth()
            .backgroundColor(Template5Theme.Background2.getColorOpacity2())
            .padding(
                top=50.px,
                bottom = 120.px,
                leftRight = 24.px
            ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Template5SectionTitle(
            badge = ResKey.TEMPLATE5_REVIEWS_BADGE,
            title = ResKey.TEMPLATE5_REVIEWS_TITLE,
            text = ResKey.TEMPLATE5_REVIEWS_TEXT
        )

        Spacer()

        Template5ReviewCard(
            currentReview
        )

        Spacer()

        Template5ReviewDots(
            clickedIndex = clickedIndex.value,
            onClicked = {clickedIndex.value=it}
        )

    }

}

@Composable
private fun Template5ReviewCard(
    review: Template5Review
) {

    Column(
        modifier = Template5ReviewPaddingStyle.toModifier()
            .maxWidth(760.px)
            .backgroundColor(Colors.White)
            .borderRadius(36.px)
            .border(
                width = 1.px,
                color = Template5Theme.Primary.rgb,
                style = LineStyle.Solid
            )
            .boxShadow(
                offsetY = 20.px,
                blurRadius = 60.px,
                color = rgba(0,0,0,.3)
            ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        AnjurosImage(
            modifier = Modifier.size(200.px)
                .objectFit(ObjectFit.ScaleDown),
            src = review.icon,
            alt = ""
        )

        //Spacer()

        //FiveStars()

        Spacer()

        P(
            attrs = Template5ReviewSizeStyle.toModifier()
                .fontStyle(FontStyle.Italic)
                .textAlign(TextAlign.Center)
                .color(rgb(70,70,70))
                .margin(top=20.px,bottom = 10.px)
                .toAttrs()
        ) {
            Text(LocalText(review.review))
        }

        Spacer()

        Span(
            attrs = Modifier
                .fontSize(20.px)
                .fontWeight(FontWeight.Bold)
                .color(Template5Theme.Primary.getColor())
                .toAttrs()
        ) {
            Text(LocalText(review.author))
        }

        Span(
            attrs = Modifier
                .fontSize(15.px)
                .color(rgb(140,140,140))
                .margin(top = 6.px)
                .toAttrs()
        ) {
            Text(LocalText(review.job))
        }

    }

}

@Composable
private fun Template5ReviewDots(
    clickedIndex:Int,
    onClicked: (index:Int) -> Unit
) {

    Row(
        modifier = Modifier.margin(top = 25.px),
        horizontalArrangement = Arrangement.spacedBy(10.px),
        verticalAlignment = Alignment.CenterVertically
    ) {

        repeat(Template5Review.entries.size) {index->

            Box(
                modifier = Modifier
                    .size(
                        if (index == clickedIndex) 14.px else 10.px
                    )
                    .cursor(Cursor.Pointer)
                    .borderRadius(50.percent)
                    .backgroundColor(
                        if (index == clickedIndex)
                            Template5Theme.Primary.getColor()
                        else
                            Template5Theme.PrimaryLight.getColorOpacity()
                    ).onClick {
                        onClicked(index)
                    }
            )

        }

    }

}

